import React from 'react';
import { motion } from 'framer-motion';
import { Home, Sofa, ChefHat, Building, Palette, Wrench, ArrowRight } from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Home size={32} />,
      title: 'Interior Design',
      description: 'Complete home and office interior design solutions with personalized touch and modern aesthetics.',
      features: ['Space Planning', 'Color Consultation', 'Lighting Design', '3D Visualization'],
      image: '/images/livingroom2.jpg'
    },
    {
      icon: <Sofa size={32} />,
      title: 'Custom Furniture',
      description: 'Handcrafted furniture designed and built in our workshops, delivered to your doorstep.',
      features: ['Beds & Wardrobes', 'Sofas & Chairs', 'Dining Sets', 'Study Tables'],
      image: '/images/jmjbeds.jpg'
    },
    {
      icon: <ChefHat size={32} />,
      title: 'Modular Kitchen',
      description: 'Modern modular kitchen designs with high-quality imported fittings and smart storage solutions.',
      features: ['Kitchen Design', 'Premium Fittings', 'Smart Storage', 'Installation'],
      image: '/images/Kitchen Drawers.jpg'
    },
    {
      icon: <Building size={32} />,
      title: 'Commercial Interiors',
      description: 'Professional interior design for hotels, restaurants, offices, and commercial spaces.',
      features: ['Hotel Interiors', 'Restaurant Design', 'Office Spaces', 'Retail Stores'],
      image: '/images/Hotel Lobby Interior Design.jpg'
    },
    {
      icon: <Palette size={32} />,
      title: 'Design Consultation',
      description: 'Expert advice on design themes, color schemes, and space optimization for your projects.',
      features: ['Design Planning', 'Theme Selection', 'Material Guidance', 'Budget Planning'],
      image: '/images/Custom Interior Lighting.jpg'
    },
    {
      icon: <Wrench size={32} />,
      title: 'Renovation',
      description: 'Complete home and office renovation services with modern design and quality craftsmanship.',
      features: ['Home Renovation', 'Office Makeover', 'Space Upgrade', 'Modern Updates'],
      image: '/images/s2.jpg'
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="services-hero-content"
          >
            <h1 className="font-display">Our Services</h1>
            <p>
              Comprehensive interior design and furniture solutions tailored to transform 
              your space into something extraordinary.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-detailed-grid">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className={`service-detailed-card ${index % 2 === 1 ? 'reverse' : ''}`}
              >
                <div className="service-detailed-content">
                  <div className="service-detailed-icon">
                    {service.icon}
                  </div>
                  <h2>{service.title}</h2>
                  <p>{service.description}</p>
                  
                  {/* Mobile image placement */}
                  <div className="service-detailed-image mobile-image">
                    <img src={service.image} alt={service.title} />
                  </div>
                  
                  <ul className="service-detailed-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx}>
                        <ArrowRight size={16} />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="btn btn-outline">
                    Learn More
                    <ArrowRight size={20} />
                  </button>
                </div>
                
                {/* Desktop image placement */}
                <div className="service-detailed-image desktop-image">
                  <img src={service.image} alt={service.title} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="cta-content"
          >
            <h2 className="font-display">Ready to Transform Your Space?</h2>
            <p>
              Let our expert team help you create the perfect interior that reflects 
              your style and meets your needs.
            </p>
            <button className="btn btn-primary">
              Get Free Consultation
              <ArrowRight size={20} />
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services;